const models = [
  {
    model: 'Project delivery',
    when: 'Defined scope, fixed milestones, and a clear end state — greenfield products or major feature builds.',
    how: 'Scoped sprints with agreed deliverables, review gates, and a formal handover at completion.',
  },
  {
    model: 'Dedicated team',
    when: 'Ongoing product evolution where you need a stable engineering unit embedded in your roadmap.',
    how: 'A senior-led squad working exclusively on your backlog, with direct access to your tools and stakeholders.',
  },
  {
    model: 'Team augmentation',
    when: 'Capacity gaps in your existing team — specialized skills or parallel workstreams without long hiring cycles.',
    how: 'Engineers integrated into your processes, standups, and review culture, operating under your direction.',
  },
]

/** Engagement schedule — three stamped cells side by side, not another table. */
export function Models() {
  return (
    <section id="models" className="bg-sheet">
      <div className="mx-auto max-w-[100rem] px-6 py-12 lg:px-8 lg:py-16">
        <div className="mb-6 flex flex-col gap-2 border-b-2 border-ink pb-4 sm:flex-row sm:items-end sm:justify-between">
          <h2 className="section-title text-ink">Engagement models</h2>
          <p className="text-sm leading-relaxed text-ink-muted sm:max-w-sm sm:text-right">
            Three ways to work with us — structured for clarity, not for upselling.
          </p>
        </div>

        <div className="cell grid divide-y divide-rule lg:grid-cols-3 lg:divide-x lg:divide-y-0">
          {models.map((row) => (
            <article key={row.model} className="flex flex-col px-5 py-6 sm:px-7 lg:py-8">
              <h3 className="entry-title text-ink">{row.model}</h3>

              <div className="mt-5 flex-1 space-y-5">
                <div>
                  <p className="cell-label text-ink-muted">When it fits</p>
                  <p className="mt-2 text-[0.9375rem] leading-relaxed text-ink-muted">
                    {row.when}
                  </p>
                </div>
                <div>
                  <p className="cell-label text-ink-muted">How it runs</p>
                  <p className="mt-2 text-[0.9375rem] leading-relaxed text-ink-muted">
                    {row.how}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
